import BaseAPIs, {iApiBasicResponse, iBasicListingResponse} from "./base.apis";
import {iDiscipline, PublicationStatuses} from "./common.apis";
import axios, {CancelTokenSource} from "axios";
import {iProduct} from "./admin/ecomerce/product.apis";
import {iBindingType} from "./admin/ecomerce/binding.types.apis";
import {iBanner} from "./admin/ecomerce/Banners.apis";
import fileDownload from "js-file-download";
import {iSeries} from "./admin/ecomerce/series.apis";

interface AccessTypeFilter {
    id: number
    available: boolean
    code: string
    name: string
}

export interface iFilter {
    statuses: PublicationStatuses[],
    disciplines: iDiscipline[],
    binding_types: iBindingType[],
    access_types: AccessTypeFilter[]
}

export interface iGuestProductResponse extends iApiBasicResponse {
    filters?: iFilter,
    results?: iBasicListingResponse<iProduct>
}

export interface iGuestSingleProductResponse extends iApiBasicResponse {
    product?: iProduct
}
export interface iGuestSingleSeriesResponse extends iApiBasicResponse {
    series?: iSeries
}

export interface iGuestBannerResponse extends iApiBasicResponse {
    banners: iBanner[]
}

export interface iSearchResult extends iApiBasicResponse {
    products?: iProduct[],
    series?: iSeries[]
}

export default class ProductApis extends BaseAPIs {
    search_products = async (source: CancelTokenSource, keyword: string): Promise<iSearchResult> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/products/suggest", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                params: {
                    keyword: keyword
                },
                cancelToken: source.token
            })
            .then((res): iSearchResult => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    }
    list_banner = async (source: CancelTokenSource): Promise<iGuestBannerResponse> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/banners/all", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                cancelToken: source.token
            })
            .then((res): iGuestBannerResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    }
    list = async (data: any, source: CancelTokenSource): Promise<iGuestProductResponse> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/products", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                params: data,
                cancelToken: source.token
            })
            .then((res): iGuestProductResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    }
    view_series = async (id:number, source: CancelTokenSource): Promise<iGuestSingleSeriesResponse> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/series/"+id, {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                cancelToken: source.token
            })
            .then((res): iGuestSingleSeriesResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    }
    view_product = async (id: string, source: CancelTokenSource): Promise<iGuestSingleProductResponse> => {
        return axios
            .get(this.getApiBaseURL() + "/_api/v1/products/" + id, {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                cancelToken: source.token
            })
            .then((res): iGuestSingleProductResponse => ({statusCode: res.status, ...res.data}))
            .catch((error): any => {
                return this.handleCatch(error);
            })
    }
    product_pdf_file = (product_id: number,
                        variant_id: number,
                        title: string
    ): any => {
        axios
            .get(this.getApiBaseURL() + "/_api/v1/products/" + product_id + "/variants/" + variant_id + "/pdf_file", {
                headers: {"Content-Type": "application/json"},
                withCredentials: true,
                params: {
                    download: "1",
                },
                responseType: "blob"
            })
            .then((res: any): any => {
                fileDownload(res.data, "sage_spectrum_" + title + ".pdf");
            })
            .catch((error): any => {

            })
    }
}
